const communityBackofficeRoutes = [
  {
    path: '',
    name: 'Posts',
    meta: {
      title: {
        en: 'Backoffice Community',
        ru: 'Управление Сообществом',
      },
      authorize: [],
    },
    component: () => import(/* webpackChunkName: 'BackofficeCommunity' */ '../components/pages/Posts.vue'),
  },
];

export default communityBackofficeRoutes;
